import { combineLatest, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { VariationValue } from '@harnessio/ff-javascript-client-sdk';

import { Api } from '../../../../shared/constants/api';
import { FeatureFlagService } from './feature-flag.service';
import { ActivatedRouteData } from '../../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  /**
   * This class is used to evaluate a flag against a specific route.
   *
   * @param featureFlagService
   * @param router
   */
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> | UrlTree {
    const featureFlags: string[] = [route.data[ActivatedRouteData.featureFlag] ?? []].flat();
    const forbiddenPage: UrlTree = this.router.parseUrl(Api.forbidden);

    if (featureFlags.length === 0) {
      console.warn('[FeatureFlagGuard.canActivate] A feature flag id must be provided.');
      return forbiddenPage;
    }

    return combineLatest(
      featureFlags.map((flag: string): Observable<VariationValue> => this.featureFlagService.variation$(flag)),
    ).pipe(map((values: VariationValue[]): UrlTree | boolean => (values.every(Boolean) ? true : forbiddenPage)));
  }
}
